module.exports = __webpack_public_path__ + "img/Pr21.1179cd62.png";